import { combineDucks } from "lib/utils/duck";

import AccommodationCalendarView from "./AccommodationCalendarView";
import AccommodationCommonView from "./common";

export default combineDucks({
  AccommodationCalendarView,
  AccommodationCommonView,
});



// WEBPACK FOOTER //
// ./src/modules/accommodation/index.js